import labelsApi from "../../api/labels";

const state = () => ({
  loaded: false,
  errored: false,

  all: []
});

const getters = {};

const actions = {
  fetchAll({ commit }) {
    labelsApi.getAll((error, labels) => {
      if (error !== null) commit("setError", error);
      else commit("setLabels", labels);
    });
  }
};

const mutations = {
  setLabels(state, labels) {
    state.all = labels;

    state.loaded = true;
    state.error = false;
  },

  setError(state, error) {
    console.log(error);

    state.loaded = false;
    state.errored = true;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
